import React, { Component } from "react";
import _ from "underscore";
import moment from "moment";
import ReactScroll from "react-scroll";
import Experiments from "lib/experiments";
import Defer from "lib/defer";
import {
    isIos,
    isIphone,
    isMobile,
    isDefaultPhone,
    formatPhone,
} from "helpers/ApplicationHelper";
import { setSticky } from "actions/header";
import { scheduleAppointment } from "actions/user";
import ErrorBoundary from "components/errorBoundary";
import Message from "components/chatBot/messageTypes/message";
import OneButton from "components/chatBot/messageTypes/oneButton";
import UploadImage from "components/chatBot/messageTypes/uploadImage";
import TwoButtons from "components/chatBot/messageTypes/twoButtons";
import MultipleButtons from "components/chatBot/messageTypes/multipleButtons";
import PhoneInput from "components/chatBot/messageTypes/phoneInput";
import RichMultipleButtons from "components/chatBot/messageTypes/richMultipleButtons";
import FreeText from "components/chatBot/messageTypes/freeText";
import ShippingLabel from "components/item/shippingLabel";
import ScheduleAppointment from "components/chatBot/messageTypes/scheduleAppointment";
import I18n from "lib/i18n/i18n";
import { browserHistory } from "react-router";
import worthyApi from "lib/api/worthyApi";
import { getItem, chatBotSaveLog } from "actions/item";
import { setCuiVersion } from "actions/cuiVersion";

class BaseChatBot extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lastMessage: null,
            lastMessages: [],
            conversationPos: 0,
            conversation: [],
            chatBotType: props.chatBotType || "standard",

            pendingRequest: false,
            hideWaves: true,
            nextUpdateConversation: null,
            haveShippingLabel: false,
            shipmentPreferences: null,
            pickupPreferences: {
                timeText: null,
            },
            pickupConfirmationNumber: null,
            shippingLabelCreated: false,
            csaStyle: {
                display: "block",
            },
            avatarStyle: {
                display: "block",
            },
            skipAvatarMovement: false,
            faqFirst: false,
            isMounted: false,
            shortSellDescription: props.shortSellDescription,
            shortSellDescriptionDesktopExp:
                props.shortSellDescriptionDesktopExp,
            returnToCuiStates: I18n.getString(
                "conversationFlow::back_to_cui::states"
            ), //list of the states that we support in return to cui feature
            isReturnedToCUI: false,
            reschedule_pickup_attempts:
                props.item && !props.chatBotType
                    ? props.item.reschedule_pickup_attempts
                    : 0,
            photos: {},
            JBReady: undefined,
        };

        if (props.Experiments) {
            let experiments = new Experiments(props.Experiments),
                conversation =
                    props.conversations[
                        experiments.chatBotExperimentTest(
                            this.isLastNameEmpty(props)
                                ? "missingDetails"
                                : props.chatBotType,
                            props.ADO,
                            props.item,
                            props.P13N
                        )
                    ],
                conversationFlow = _.map(conversation.flow, function (message) {
                    return message;
                });
            this.props.setCuiVersion(conversation.version);
            Object.assign(this.state, {
                experiments,
                rawConversation: conversationFlow,
                conversationVersion: conversation.version,
                conversationConstMessages: conversation.const_messages,
                conversationFlow: JSON.parse(
                    this.textReplace(JSON.stringify(conversationFlow))
                ),
                showAvatar: conversation["showAvatar"],
            });
        }

        this.textReplace = this.textReplace.bind(this);
        this.oneButtonClick = this.oneButtonClick.bind(this);
        this.onChangePhoto = this.onChangePhoto.bind(this);
        this.buttonsClick = this.buttonsClick.bind(this);
        this.removeFromConversation = this.removeFromConversation.bind(this);
        this.onTimeSelect = this.onTimeSelect.bind(this);
        this.onSubmitFreeText = this.onSubmitFreeText.bind(this);
        this.saveLog = this.saveLog.bind(this);
        this.scheduleAppointmentCallback =
            this.scheduleAppointmentCallback.bind(this);
        this.renderMessage = this.renderMessage.bind(this);
        this.updatePositions = this.updatePositions.bind(this);
        this.updatePhotoConversationFlow =
            this.updatePhotoConversationFlow.bind(this);
    }

    get headerHeight() {
        return isMobile() ? "14vmin" : "60px";
    }

    get userPhoneDashed() {
        let phone = this.props.Session.userData.phone;
        return formatPhone(phone);
    }

    get allowedImageTypes() {
        return ["image/png", "image/jpeg", "image/x-png"];
    }

    componentDidMount() {
        if (isMobile()) this.props.setSticky(false);
        ReactScroll.animateScroll.scrollToTop({
            duration: 0,
            smooth: true,
        });

        let item = this.props.item;

        try {
            if (
                ["standard"].includes(this.state.chatBotType) &&
                (Object.keys(this.state.returnToCuiStates).includes(
                    item.bundle.workflow_state
                ) ||
                    item.has_submission_photo) &&
                this.state.conversationPos === 0
            ) {
                this.setConversation(this.props);
                this.continueConversationHandler();
            }
        } catch (e) {
            console.log("state: " + JSON.stringify(this.state));
            console.log("item: " + JSON.stringify(item));
            console.log(e, e.stack);
            throw e;
        }

        this.setState({ isMounted: true });
    }

    setConversation(props) {
        if (
            this.state.chatBotType !== "jewelryBox" &&
            this.state.chatBotType !== "highValue" &&
            props.ADO &&
            this.isLastNameEmpty(props)
        )
            this.setState({ chatBotType: "missingDetails" });

        if (props.Experiments && !this.state.experiments) {
            let experiments = new Experiments(props.Experiments),
                JBChat = this.state.chatBotType === "jewelryBox",
                jbProps = JBChat && props.jewelryBox,
                conversation =
                    props.conversations[
                        experiments.chatBotExperimentTest(
                            this.state.chatBotType,
                            props.ADO,
                            props.item,
                            props.P13N
                        )
                    ];
            if (JBChat)
                conversation = this.setJbConversation(jbProps, conversation);
            let conversationFlow = _.map(conversation.flow, function (message) {
                return message;
            });
            this.props.setCuiVersion(conversation.version);
            this.setState(
                {
                    experiments,
                    rawConversation: conversationFlow,
                    conversationVersion: conversation.version,
                    conversationConstMessages: conversation.const_messages,
                    conversationFlow: JSON.parse(
                        this.textReplace(
                            JSON.stringify(conversationFlow),
                            props
                        )
                    ),
                },
                this.updateConversation
            );
            this.conversationFlowSet = true;
        }

        if (this.props.Session && !this.conversationFlowSet) {
            this.setState(
                {
                    conversationFlow: JSON.parse(
                        this.textReplace(
                            JSON.stringify(this.state.rawConversation)
                        )
                    ),
                },
                this.updateConversation
            );
            this.conversationFlowSet = true;
        }
    }

    updatePhotoConversationFlow(conversationFlow) {
        let conversation =
            this.props.conversations[
                this.state.experiments.chatBotExperimentTest(
                    this.state.chatBotType,
                    this.props.ADO,
                    this.props.item,
                    this.props.P13N
                )
            ];

        let positionKey =
            conversation["const_messages"] &&
            conversation["const_messages"]["welcomeBackSubmissionPhoto"] &&
            conversation["const_messages"]["welcomeBackSubmissionPhoto"][
                "jump_to_key"
            ];
        let positionIndex = this.state.conversationFlow.findIndex(
            (o) => o.key === positionKey
        );
        if (positionIndex) {
            conversationFlow.splice(0, positionIndex);
            conversationFlow.unshift(
                conversation["const_messages"]["welcomeBackSubmissionPhoto"]
            );
        }
        return conversationFlow;
    }

    setJbConversation(jbProps, conversation) {
        let res;
        if (jbProps) {
            if (jbProps.last_appointment && jbProps.has_submission_photo)
                res = 2;
            else if (jbProps.has_submission_photo) res = 1;
            else if (jbProps.last_appointment) res = 3;
        }
        res = res || 0;
        return conversation[res];
    }

    getJBAppointment(last_appointment) {
        return BaseChatBot.getAppointmentTime(moment(last_appointment));
    }

    componentWillReceiveProps(newProps) {
        if (this.props.Session && !this.props.Session.isLoggedIn)
            return browserHistory.push("/register");

        if (this.state.isMounted) {
            //In case there's no jeweleryBox prop get it from the parent again
            if (
                this.state.chatBotType === "jewelryBox" &&
                !newProps.jewelryBox
            ) {
                return this.props
                    .getJewelryBoxUserData(this.props.routeParams.id)
                    .then(() => this.setConversation(newProps));
            }

            this.setConversation(newProps);
        }

        this.setState({ isMounted: true });
    }

    componentWillUpdate() {
        if (this.lastDocHeight !== document.body.offsetHeight) {
            document
                .querySelector("#content")
                .style.setProperty(
                    "height",
                    `calc(${document.body.offsetHeight}px - ${this.headerHeight})`
                );
            this.lastDocHeight = document.body.offsetHeight;
        }
    }

    componentDidUpdate() {
        if (document.body.offsetHeight !== this.lastDocHeight) {
            this.updateScrollPosition();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.state.nextUpdateConversation);
        if (isMobile()) this.props.setSticky(true);
        document.querySelector("#content").removeAttribute("style");
    }

    isLastNameEmpty(props) {
        return (
            props.ADO.user &&
            props.ADO.user.last_name === "" &&
            props.chatBotType !== "highValue"
        );
    }

    /**
     *
     * @param props
     * @returns {__I18N__.en.conversationFlow.jewelryBox|{'0', '1', '2'}|*}
     */
    isThereJbProps(properties = false) {
        return (
            (properties.jewelryBox && properties.jewelryBox.last_appointment) ||
            (this.props.jewelryBox && this.props.jewelryBox.last_appointment)
        );
    }

    textReplace(text, properties = false) {
        if (!this.props.Session) return text;
        let jbWithOldAppointment =
            this.props.chatBotType === "jewelryBox" &&
            this.isThereJbProps(properties) &&
            !this.state.appointmentTime;
        text = text.replace(
            /#{user_first_name}/g,
            this.props.Session.userData.first_name
        );
        text = text.replace(
            /#{user_email}/g,
            this.props.Session.userData.email
        );
        if (!isDefaultPhone(this.props.Session.userData.phone))
            text = text.replace(/#{user_phone}/g, this.userPhoneDashed);
        this.props.Session.userData.account_manager &&
            (text = text.replace(
                /#{account_manager_name}/g,
                this.props.Session.userData.account_manager.name.split(" ")[0]
            ));
        let appointment = this.state.appointmentTime;

        if (jbWithOldAppointment) {
            let used_props = properties || this.props;

            appointment = this.getJBAppointment(
                used_props.jewelryBox.last_appointment.scheduled_time
            );
        }

        if (appointment) {
            const firstWord =
                    (appointment.is_today && "Today") ||
                    (appointment.is_tomorrow && "Tomorrow") ||
                    appointment.day,
                isTodayOrTomorrow =
                    appointment.is_today || appointment.is_tomorrow;
            if (jbWithOldAppointment) {
                text = text.replace(
                    /#{new_selected_time_full}/g,
                    `${firstWord.toLowerCase()} ${
                        isTodayOrTomorrow ? "(" + appointment.day + ") " : " "
                    }at ${appointment.hour}`
                );
            } else {
                text = text.replace(
                    /#{selected_time_day_hour}/g,
                    `${firstWord} at ${appointment.hour}`
                );
                text = text.replace(
                    /#{selected_time_full}/g,
                    `${firstWord.toLowerCase()} ${
                        isTodayOrTomorrow ? "(" + appointment.day + ") " : " "
                    }at ${appointment.hour}`
                );
            }
            text = text.replace(/#{timezone}/g, `(${appointment.timezone})`);
        }
        return text;
    }

    /**
     * this function is called right after cui's initialization, before the component is starting to be rendered.
     * this function identifies the item state, renders "welcome back" message, and finally getting the state of the cui
     * to return to by the "message_key" and updates the conversationPos.
     */
    continueConversationHandler() {
        let backToCUIMessage = I18n.getString("conversationFlow::back_to_cui"),
            workflowState = this.props.item.bundle.workflow_state;

        let conversationFlow = this.state.conversationFlow;
        if (backToCUIMessage["states"][workflowState]) {
            conversationFlow[0] = backToCUIMessage;
            conversationFlow[1] = backToCUIMessage["states"][workflowState];
        } else if (this.props.item.has_submission_photo) {
            this.updatePhotoConversationFlow(conversationFlow);
        }

        this.setState({ conversationFlow });
    }

    /**
     * this function gets the last message class names and identifies if its a seller message or bot,
     * and transitions the profile picture of the message source to be next to the latest source message.
     * @param classNames
     */
    updatePositions(classNames) {
        if (this.state.lastMessage.type === "method") return;
        if (
            classNames === undefined ||
            document.getElementsByClassName(classNames).length == 0 ||
            this.state.skipAvatarMovement
        ) {
            this.setState({ skipAvatarMovement: false });
            return;
        }

        let messageDirection = classNames.includes("outgoing")
                ? "outgoing"
                : "incoming",
            lastTextMessage = document.getElementsByClassName(classNames),
            chatBotCont = document.getElementById("chat-bot"),
            style = {},
            chatBotHeight =
                chatBotCont.getBoundingClientRect().bottom -
                chatBotCont.getBoundingClientRect().top;

        lastTextMessage = lastTextMessage[lastTextMessage.length - 1];

        if (
            classNames === "message message-text fade-in" ||
            classNames === "picture"
        ) {
            if (this.state.chatBotType === "highValue") return;

            if (isMobile() || classNames === "picture") chatBotHeight += 65;

            Object.assign(style, this.state.csaStyle, {
                transform: `translateY(calc(${chatBotHeight}px - 115px))`,
            });
            this.setState({ csaStyle: style });
            return;
        }

        if (lastTextMessage.classList.contains(messageDirection)) {
            if (isMobile) chatBotHeight += 5;

            if (classNames.includes("picture")) {
                chatBotHeight -= 65;
            }

            Object.assign(
                style,
                messageDirection == "outgoing"
                    ? this.state.avatarStyle
                    : this.state.csaStyle,
                { transform: `translateY(calc(${chatBotHeight}px - 95px))` }
            );

            if (messageDirection == "outgoing")
                this.setState({ avatarStyle: style });
            else this.setState({ csaStyle: style });
        }
    }

    removeFromConversation(message) {
        var conversation = this.state.conversation;
        conversation.splice(_.indexOf(conversation, message), 1);
        this.setState({ conversation });
    }

    oneButtonClick(message) {
        this.removeFromConversation(message);
        this.pushSellerMessage(message.response);
        ReactScroll.animateScroll.scrollToBottom({
            duration: 1000,
            delay: 0,
            smooth: true,
        });
    }

    onTimeSelect(message, selectedTime) {
        switch (selectedTime) {
            case "Tomorrow":
            case "Today":
                this.removeFromConversation(message);
                this.setState({ appointmentTime: null });

                let responseOtherDay = _.map(
                    message.response_other_day,
                    (message) => {
                        return message;
                    }
                );
                this.state.conversationFlow.splice(
                    this.state.conversationPos,
                    0,
                    ...responseOtherDay
                );

                this.updateConversation();
                break;
            default:
                this.removeFromConversation(message);
                const time = moment(selectedTime),
                    appointmentTime = BaseChatBot.getAppointmentTime(time);
                this.setState(
                    { appointmentTime, selectedAppointmentTime: selectedTime },
                    () => {
                        let responseTimeSelected = _.map(
                            JSON.parse(
                                this.textReplace(
                                    JSON.stringify(
                                        message.response_time_selected
                                    )
                                )
                            ),
                            (message) => {
                                return message;
                            }
                        );
                        this.state.conversationFlow.splice(
                            this.state.conversationPos,
                            0,
                            ...responseTimeSelected
                        );
                        this.updateConversation();
                    }
                );
                break;
        }
    }

    buttonsClick(message, chosen) {
        let conversationPosInc = 0;
        const itemId = this.props.item && this.props.item.id;

        // Remove from conversation
        this.removeFromConversation(message);

        // Update state
        if (chosen.update_state) {
            let updateState = Object.assign(
                {},
                this.state,
                chosen.update_state
            );
            this.setState(updateState);
        }

        // Initial response
        if (message.initial_response) {
            let afterResponse = _.map(message.initial_response, (message) => {
                return message;
            });
            this.state.conversationFlow.splice(
                this.state.conversationPos + conversationPosInc,
                0,
                ...afterResponse
            );
            conversationPosInc += afterResponse.length;
        }

        // Chosen response
        let response = _.map(chosen.response, (message) => {
            return message;
        });
        this.state.conversationFlow.splice(
            this.state.conversationPos,
            0,
            ...response
        );
        conversationPosInc += response.length;

        // Default response
        if (chosen.default_response && message[chosen.default_response]) {
            let defaultResponse = _.map(
                message[chosen.default_response],
                (message) => {
                    if (chosen.action && chosen.followUpMessage) {
                        message["action"] = chosen.action;
                        message["followUpMessage"] = chosen.followUpMessage;
                    }
                    return message;
                }
            );
            this.state.conversationFlow.splice(
                this.state.conversationPos + conversationPosInc,
                0,
                ...defaultResponse
            );
            conversationPosInc += defaultResponse.length;
        }

        if (chosen.jumpToEnd) {
            this.state.conversationFlow.splice(
                this.state.conversationPos +
                    Object.keys(chosen.response).length,
                this.state.conversationFlow.length - this.state.conversationPos
            );
        }

        if (chosen.stopConversation) {
            this.state.conversationFlow.splice(
                this.state.conversationPos + 1,
                this.state.conversationFlow.length - this.state.conversationPos
            );
        }

        if (
            chosen.action === "update_pickup_details_time" &&
            this.state.reschedule_pickup_attempts >= 3
        ) {
            worthyApi.createShipmentMethodDetailsTask(
                itemId,
                "update_pickup_details_time"
            );
            worthyApi.setReschedulePickupAttempt(itemId);
            this.props.getItem(itemId);
            this.setState({
                reschedule_pickup_attempts:
                    this.state.reschedule_pickup_attempts + 1,
            });
        } else if (chosen.action === "open_listing_page") {
            chatBotSaveLog(
                itemId,
                {
                    key: "button_click",
                    direction: "2",
                    type: "button_click",
                    text: `'${chosen.text}' button clicked`,
                },
                this.state.conversationVersion
            );
            browserHistory.push(`/listing/${itemId}`);
            window.scrollTo(0, 0); // scroll-restoration for listing draft
            return;
        } else {
            this.updateConversation();
        }

        ReactScroll.animateScroll.scrollToBottom({
            duration: 1000,
            delay: 0,
            smooth: true,
        });
    }

    timeToShowNextMessage() {
        var conversationPos = this.state.conversationPos;
        return conversationPos <=
            Object.keys(this.state.conversationFlow).length - 1 &&
            parseInt(this.state.conversationFlow[conversationPos].direction) >
                0 &&
            !this.ignoreTimeToShow(
                "shipping",
                this.state.conversationFlow[conversationPos]
            )
            ? this.state.conversationFlow[conversationPos].time_to_show
                ? parseInt(
                      this.state.conversationFlow[conversationPos].time_to_show
                  )
                : 4000
            : 350;
    }

    showWaves(message) {
        var conversationPos = this.state.conversationPos;
        if (
            message.key.startsWith("message_welcome_") &&
            !message.key.startsWith("message_welcome_back")
        )
            return;
        if (parseInt(message.hide_waves_timeout) === 0) return;

        setTimeout(() => {
            if (
                this.state.conversationPos >=
                Object.keys(this.state.conversationFlow).length
            )
                return;
            if (
                conversationPos <=
                    Object.keys(this.state.conversationFlow).length - 1 &&
                parseInt(
                    this.state.conversationFlow[conversationPos].direction
                ) > 0 &&
                parseInt(message.direction) > 0 &&
                !this.ignoreTimeToShow(
                    "shipping",
                    this.state.conversationFlow[conversationPos]
                )
            ) {
                this.setState({ hideWaves: false });
            }
        }, 800);
    }

    ignoreTimeToShow(conversationState) {
        return conversationState.ignore_time_to_show_other_state;
    }

    updateLastMessages() {
        var conversationPos = this.state.conversationPos - 1;
        var conversation = this.state.conversation;
        var lastMessages = [];
        for (var i = 0; i < conversation.length; i++) {
            if (i === 0 && conversationPos != 0) {
                if (
                    conversation[i].key !== "message_welcome_back" ||
                    conversation[i].key !== "back_to_pickup_waiting_message"
                )
                    continue;
            }

            if (
                (i > 0 &&
                    conversation[i].direction !==
                        conversation[i - 1].direction) ||
                (this.state.lastMessage.key == "message_fedex_arrange_pickup" &&
                    conversation.length == 1)
            ) {
                lastMessages.push(i - 1);
            }
            if (i === 0 || i === conversation.length - 1) {
                lastMessages.push(i);
                break;
            }
        }
        this.setState({ lastMessages });

        let lastMessageReceived =
            conversation[lastMessages[lastMessages.length - 1]];
        if (
            lastMessageReceived.action !== undefined ||
            parseInt(lastMessageReceived.direction) == 1
        )
            this.updatePositions("message incoming message-text last-message");
    }

    pushSellerMessage(message, updateConversation = true) {
        let nextUpdateConversation;
        let hideWaves = true;
        this.pushToConversation(message);

        if (parseInt(message.direction) === 0 || !updateConversation) {
            return;
        }
        nextUpdateConversation = setTimeout(() => {
            this.showWaves(message);
            nextUpdateConversation = setTimeout(() => {
                this.updateConversation();
            }, this.timeToShowNextMessage());
            this.setState({ nextUpdateConversation });
        }, 1000);
        if (parseInt(message.direction) === 2) {
            this.updatePositions("message outgoing last-message");
        }
        this.setState({ nextUpdateConversation, hideWaves });
    }

    updateConversation(message = null) {
        let conversationPos = this.state.conversationPos;
        let nextUpdateConversation;
        let hideWavesTimeout = 0;
        if (!message) {
            if (
                typeof this.state.conversationFlow[conversationPos] ==
                "undefined"
            ) {
                return;
            }

            message = this.state.conversationFlow[conversationPos];
            conversationPos += 1;
            if (message.hide_waves_timeout) {
                hideWavesTimeout = parseInt(message.hide_waves_timeout);
            }
        }
        this.setState({ conversationPos, hideWaves: true });

        if (message.type === "method") {
            let stopUpdateConversation = this.methodMessageHandler(message);

            if (
                message.key === "back_to_pickup_waiting" ||
                message.key === "update_details_change_time"
            )
                message = message["message"];

            if (this.state.conversationFlow[conversationPos]) {
                this.showWaves(this.state.conversationFlow[conversationPos]);
            }

            if (!stopUpdateConversation) {
                nextUpdateConversation = setTimeout(() => {
                    this.updateConversation();
                }, this.timeToShowNextMessage());
                this.setState({ nextUpdateConversation });
                return;
            }
        }

        this.pushToConversation(message);
        this.setBubbleArrow(message);

        if (message["stop_conversation"]) {
            this.state.conversationFlow = this.state.conversationFlow.slice(
                0,
                this.state.conversationPos
            );
        }

        setTimeout(() => {
            this.showWaves(message);
        }, hideWavesTimeout);

        if (parseInt(message.direction) != 0) {
            let timeout = this.timeToShowNextMessage();
            nextUpdateConversation = setTimeout(() => {
                this.updateConversation();
            }, timeout + hideWavesTimeout);
            this.setState({ nextUpdateConversation });
        }

        return message;
    }

    pushToConversation(message) {
        var conversation = this.state.conversation;
        var pendingRequest;
        var timeNow = new Date();
        message["time"] = moment().format("HH:mm");
        if (this.state.lastMessage) {
            message["last_key"] = this.state.lastMessage.key;
        }
        if (this.state.chatBotType !== "jewelryBox")
            message = this.changeVarsInMessage(message);
        conversation.push(message);
        pendingRequest =
            message.direction > 0
                ? false
                : message.key === "multiple_buttons_pickup_done"
                ? "pending-request-big"
                : "pending-request";

        this.setState(
            { lastMessage: message, conversation, pendingRequest },
            () => {
                ReactScroll.animateScroll.scrollToBottom({
                    duration: 1000,
                    delay: 0,
                    smooth: true,
                });
            }
        );
        this.saveLog(message);
    }

    /**
     * this function gets the message and changes the string variables like addresses, names etc... to the user's data.
     * @param message
     * @returns {*}
     */
    changeVarsInMessage(message) {
        let addressFormat = ["street", "city", "state", "zipcode"],
            addressArr = this.props.item.bundle.address,
            address =
                addressArr !== undefined
                    ? addressFormat.map((part) => addressArr[part]).join(", ")
                    : "";
        let fields = {
            new_phone: this.userPhoneDashed,
            user_first_name: this.props.Session.userData.first_name,
            user_address: address + ".",
            schedule_pickup_address: address,
            item_desc: this.props.item.desc,
        };

        if (this.state.chatBotType === "watch") {
            fields["watch_brand"] =
                this.props.item.details && this.props.item.details.brand;
            fields["watch_model"] =
                this.props.item.details && this.props.item.details.model;
        }
        for (let field in fields) {
            if (message.text && message.text.includes(field)) {
                let text = message.text.replace(
                    "#{" + field + "}",
                    fields[field]
                );
                Object.assign(message, { text: text });
            }
        }
        return message;
    }

    // Set bubble arrows in last messages
    setBubbleArrow(message) {
        // if (!message.key.includes('message_welcome')) {
        if (message.key !== "message_welcome_high_value") {
            setTimeout(() => {
                this.updateLastMessages();
            }, 350);
        }
    }

    updateScrollPosition() {
        if (document.getElementsByClassName("popup").length) return;
        ReactScroll.animateScroll.scrollMore(
            Math.max(0, document.body.offsetHeight - this.lastDocHeight),
            {
                duration: 0,
                delay: 0,
                smooth: true,
            }
        );
    }

    onInputBlur() {
        (isMobile() || isIos()) &&
            ReactScroll.animateScroll.scrollToBottom({
                duration: 0,
                delay: 0,
                smooth: true,
            });
    }

    csaImage() {
        return this.props.Session.userData.account_manager.image
            ? `url(${this.props.Session.userData.account_manager.image})`
            : null;
    }

    avatarImage() {
        return this.props.Session.userData._userData.image_url
            ? `url(${this.props.Session.userData._userData.image_url})`
            : null;
    }

    render(chatBotClass, csaClass, title, errorTemplate) {
        if (!this.props.Session) return null;

        let csaImage = this.csaImage(),
            avatarImage = this.avatarImage(),
            show_csa = this.state.conversation.find((msg) => {
                return parseInt(msg.direction) === 1;
            })
                ? this.state.csaStyle
                : { display: "none" },
            show_avatar = this.state.conversation.find((msg) => {
                return parseInt(msg.direction) === 2;
            })
                ? this.state.avatarStyle
                : { display: "none" };

        csaImage &&
            (show_csa = Object.assign({}, show_csa, {
                backgroundImage: csaImage,
            }));
        avatarImage &&
            (show_avatar = Object.assign({}, show_avatar, {
                backgroundImage: avatarImage,
            }));
        return (
            <ErrorBoundary template={errorTemplate}>
                <div
                    id="chat-bot"
                    className={`${
                        this.state.pendingRequest
                            ? this.state.pendingRequest
                            : ""
                    } ${chatBotClass}`}
                >
                    <div
                        className={
                            this.state.shortSellDescriptionDesktopExp
                                ? "whats-next-chat-bot whats-next-chat-bot-short"
                                : "whats-next-chat-bot"
                        }
                    >
                        <div className="title">{title}</div>
                    </div>
                    {this.state.conversation.map(this.renderMessage)}
                    <div
                        id="wave"
                        className={this.state.hideWaves ? "hide-waves" : ""}
                    >
                        <span className="dot" />
                        <span className="dot" />
                        <span className="dot" />
                    </div>
                    <div
                        className={`csa fade-in ${csaClass}`}
                        style={show_csa}
                    />
                    {this.state.showAvatar ? (
                        <div
                            className={`avatar fade-in ${csaClass}`}
                            style={show_avatar}
                        >
                            {!this.props.Session.userData._userData
                                .image_url ? (
                                <div className={"no-image"}>
                                    {this.props.Session.userData.first_name[0]}
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </ErrorBoundary>
        );
    }

    renderMessage(message, i) {
        const oldAppointment =
            this.props.jewelryBox &&
            this.props.jewelryBox.last_appointment &&
            this.getJBAppointment(
                this.props.jewelryBox.last_appointment.scheduled_time
            );
        if (oldAppointment && !this.state.appointmentTime)
            this.setState({ appointmentTime: oldAppointment });
        switch (message.type) {
            case "message":
                return (
                    <Message
                        key={i}
                        message={message}
                        lastMessage={this.state.lastMessages.includes(i)}
                        avatarUpdate={this.updatePositions}
                        avatarTestMode={this.state.showAvatar}
                        shortSellDescriptionDesktopExp={
                            this.state.shortSellDescriptionDesktopExp
                        }
                    />
                );
            case "one_button":
                return (
                    <OneButton
                        id="input-continue"
                        key={i}
                        message={message}
                        onClick={this.oneButtonClick}
                    />
                );
            case "add_photo_button":
                return (
                    <OneButton
                        key={i}
                        position={i}
                        message={message}
                        chatBotType={this.state.chatBotType}
                        onChange={this.onChangePhoto}
                        accept={this.allowedImageTypes}
                    />
                );
            case "add_photo_button_two":
                return (
                    <TwoButtons
                        key={i}
                        position={i}
                        message={message}
                        onClick={this.buttonsClick}
                        onChange={this.onChangePhoto}
                        accept={this.allowedImageTypes}
                    />
                );
            case "photo_being_uploaded":
                return (
                    <UploadImage
                        key={i}
                        message={message}
                        image={this.state.photos[i]}
                        moveAvatar={this.updatePositions}
                    />
                );
            case "two_buttons":
                const CBHighValue = document.querySelector(
                        ".chat-bot-high-value"
                    ),
                    id = CBHighValue
                        ? "input-change-phone/done"
                        : "input-has-apt/suite";
                CBHighValue &&
                    (CBHighValue.classList.remove("pending-request"),
                    CBHighValue.classList.add("pending-request-big"));
                return (
                    <TwoButtons
                        id={id}
                        key={i}
                        message={message}
                        onClick={this.buttonsClick}
                        logsData={
                            this.state.chatBotType !== "jewelryBox"
                                ? {
                                      itemId: this.props.item.id,
                                      version: this.state.conversationVersion,
                                  }
                                : {}
                        }
                        accept={this.allowedImageTypes}
                    />
                );
            case "multiple_buttons":
                return (
                    <MultipleButtons
                        key={i}
                        message={message}
                        onClick={this.buttonsClick}
                    />
                );
            case "rich_multiple_buttons":
                return (
                    <RichMultipleButtons
                        id="input-videos"
                        key={i}
                        message={message}
                    />
                );
            case "free_text":
                isIphone() &&
                    document
                        .getElementById("chat-bot")
                        .classList.add("non-fixed-child");
                return (
                    <FreeText
                        id="input-apt/suite"
                        key={i}
                        // onFocus={this.onInputFocus.bind(this)}
                        onBlur={this.onInputBlur.bind(this)}
                        message={message}
                        className={isIphone() ? "non-fixed" : ""}
                        onSubmit={this.onSubmitFreeText}
                    />
                );
            case "schedule_appointment":
                this.deferred = this.deferred || Defer();

                return (
                    <ScheduleAppointment
                        id="input-update-details"
                        key={i}
                        message={message}
                        promise={this.deferred.promise}
                        chatBotType={this.state.chatBotType}
                        onTimeSelect={this.onTimeSelect}
                        callback={this.scheduleAppointmentCallback}
                        objectId={this.objectId}
                    />
                );

            case "request_last_name":
                isIphone() &&
                    document
                        .getElementById("chat-bot")
                        .classList.add("non-fixed-child");
                return (
                    <FreeText
                        id="input-apt/suite"
                        key={i}
                        onBlur={this.onInputBlur.bind(this)}
                        message={message}
                        freeTextField="setLastName"
                        className={isIphone() ? "non-fixed" : ""}
                        onSubmit={this.onSubmitFreeText}
                    />
                );

            case "free_text_phone":
                isIphone() &&
                    document
                        .getElementById("chat-bot")
                        .classList.add("non-fixed-child");
                return (
                    <FreeText
                        id="input-phone"
                        key={i}
                        saveLog={this.saveLog}
                        // onFocus={this.onInputFocus.bind(this)}
                        onBlur={this.onInputBlur.bind(this)}
                        message={message}
                        className={isIphone() ? "non-fixed" : ""}
                        appointmentTime={this.state.appointmentTime}
                        freeTextField="changePhone"
                        itemId={this.objectId}
                        userId={this.props.Session.userData.id}
                        userPhone={this.props.Session.userData.phone}
                        chatBotType={this.state.chatBotType}
                        onSubmit={this.onSubmitFreeText}
                    />
                );
            case "free_text_report":
            case "free_text_carat_weight":
                let reportOrCarat =
                    message.type.indexOf("report") > -1 ? "report" : "carat";
                isIphone() &&
                    document
                        .getElementById("chat-bot")
                        .classList.add("non-fixed-child");
                return (
                    <FreeText
                        id={`input-${reportOrCarat}`}
                        key={i}
                        saveLog={this.saveLog}
                        // onFocus={this.onInputFocus.bind(this)}
                        onBlur={this.onInputBlur.bind(this)}
                        message={message}
                        className={isIphone() ? "non-fixed" : ""}
                        appointmentTime={this.state.appointmentTime}
                        freeTextField={
                            reportOrCarat === "report"
                                ? "changeReport"
                                : "changeCaratWeight"
                        }
                        itemId={this.objectId}
                        userId={this.props.Session.userData.id}
                        onSubmit={this.onSubmitFreeText}
                    />
                );
            case "phone_input":
                return (
                    <PhoneInput
                        message={message}
                        finishedUpdate={this.oneButtonClick}
                    />
                );
        }
    }
    renderShippingLabel() {
        document.getElementsByClassName("desc-wrap")[0].style.display = "none";
        return <ShippingLabel item={this.props.item} />;
    }

    scheduleAppointmentCallback() {
        let messageResponse = JSON.parse(
                this.textReplace(JSON.stringify(this.state.lastMessage))
            ),
            afterResponse = _.map(messageResponse.success, (message) => {
                return message;
            });

        this.state.conversationFlow.splice(
            this.state.conversationPos,
            0,
            ...afterResponse
        );
        this.updateConversation();

        ReactScroll.animateScroll.scrollToBottom({
            duration: 1000,
            delay: 0,
            smooth: true,
        });
    }

    onSubmitFreeText(message, toState) {
        let updateState = {};
        if (message.update_state) {
            updateState[message.update_state] = toState;
            this.setState(updateState);
        }
        this.removeFromConversation(message);

        let text =
            message.text_response && toState
                ? message.text_response
                : toState
                ? toState
                : message.nothing;
        let newText = text.includes("new_phone")
            ? text.replace(/#{new_phone}/g, formatPhone(toState))
            : text;
        newText = text.includes("report_number")
            ? text.replace(/#{report_number}/g, toState)
            : newText;
        newText = text.includes("carat_weight")
            ? text.replace(/#{carat_weight}/g, toState)
            : newText;

        // Update state
        if (message.update_state) {
            this.setState({ [message.update_state]: toState });
        }

        this.pushSellerMessage(
            {
                key: message.key_response,
                direction: "2",
                type: "message",
                text: newText,
                hide_waves_timeout: "1800",
            },
            !message.update_phone
        );

        setTimeout(() => {
            if (message.update_phone) {
                while (
                    this.state.conversationFlow.length >
                    this.state.conversationPos
                )
                    this.state.conversationFlow.splice(
                        this.state.conversationPos
                    );
                this.setState({ hideWaves: false });
                let conversationPos = _.indexOf(
                        _.pluck(this.state.conversationFlow, "key"),
                        "two_buttons_after_schedule"
                    ),
                    userPhone = toState,
                    conversation = this.state.conversation,
                    changeAddressMessage =
                        this.state.conversationConstMessages
                            .message_phone_change,
                    isTodayOrTomorrow =
                        this.state.appointmentTime.is_today ||
                        this.state.appointmentTime.is_tomorrow,
                    firstWord =
                        (this.state.appointmentTime.is_today && "today") ||
                        (this.state.appointmentTime.is_tomorrow &&
                            "tomorrow") ||
                        this.state.appointmentTime.day,
                    messageToPush = {
                        key: `${changeAddressMessage.key}_${conversation.length}`,
                        direction: "1",
                        type: "message",
                        text: changeAddressMessage.originalText
                            ? changeAddressMessage.originalText
                                  .replace(
                                      /#{user_new_phone}/g,
                                      formatPhone(toState)
                                  )
                                  .replace(
                                      /#{selected_time_full}/g,
                                      `${firstWord} ${
                                          isTodayOrTomorrow
                                              ? "(" +
                                                this.state.appointmentTime.day +
                                                ") "
                                              : " "
                                      }at ${this.state.appointmentTime.hour}`
                                  )
                                  .replace(
                                      /#{timezone}/g,
                                      `(${this.state.appointmentTime.timezone})`
                                  )
                            : changeAddressMessage.text,
                        time_to_show: "0",
                        hide_waves_timeout: "1800",
                    };
                this.updateConversation(messageToPush);
                setTimeout(() => {
                    this.setState(
                        { conversation, conversationPos, userPhone },
                        this.updateConversation
                    );
                }, 1800);
            }
        }, 1000);
    }

    methodMessageHandler(message) {
        let stopUpdateConversation = false,
            positionKey,
            positionIndex;
        switch (message.method) {
            case "schedule_appointment":
                this.setState({ skipAvatarMovement: true });
                stopUpdateConversation = true;
                this.deferred.resolve(this.state.selectedAppointmentTime);
                delete this.deferred;
                break;

            case "back_to_pickup_waiting":
                stopUpdateConversation = true;
                positionKey = message["jump_to_key"];
                positionIndex = this.state.conversationFlow.findIndex(
                    (o) => o.key === positionKey
                );

                this.setState({
                    conversationPos: positionIndex,
                    isReturnedToCUI: true,
                });
                break;

            case "update_details_change_time":
                stopUpdateConversation = true;

                worthyApi.setReschedulePickupAttempt(this.props.item.id);

                positionKey = message["jump_to_key"];
                positionIndex = this.state.conversationFlow.findIndex(
                    (o) => o.key === positionKey
                );
                this.state.conversationFlow.splice(
                    this.state.conversationPos,
                    0,
                    this.state.conversationFlow[positionIndex]
                );

                this.setState({
                    reschedule_pickup_attempts: ++this.state
                        .reschedule_pickup_attempts,
                });
                if (this.state.reschedule_pickup_attempts > 3) {
                    message["stop_conversation"] = true;
                }
                break;

            case "upload_photo":
                stopUpdateConversation = true;
                this.setState({ hideWaves: false });
                this.uploadPhoto(
                    this.state.photos[this.state.position].file,
                    message
                );
                break;
        }
        return stopUpdateConversation;
    }

    onChangePhoto(message, position) {
        let file = event.target.files[0];
        let photos = this.state.photos;
        photos[position] = { file };
        this.setState({ photos, position });

        // when upload photo comes from 2 buttons feature we do have button1, otherwise we don't
        if (message.button1) this.buttonsClick(message, message.button1);
        else {
            this.removeFromConversation(message);
            this.pushSellerMessage(message.response);
        }
    }

    uploadPhoto(file, message) {
        const data = new FormData();
        data.append("file", file);
        let i = this.state.position,
            photos = this.state.photos,
            id = this.props.routeParams
                ? this.props.routeParams.id
                : this.props.item.id;

        photos[i]["uploadStatus"] = "uploading";
        this.setState({ photos });

        if (this.allowedImageTypes.indexOf(file.type) === -1)
            return this.handleUploadImageError(message, photos);

        worthyApi
            .uploadImage(data, id, this.state.chatBotType)
            .then(() => {
                photos[i]["uploadStatus"] = "success";
                this.setState({ photos });
                this.updatePhotoStatus(message, "success");
            })
            .catch((error) => {
                console.log(error);
                this.handleUploadImageError(message, photos);
            });
    }

    /**
     * React in case there's error in Upload image process
     *
     * @param message
     * @param photos
     * @constructor
     */
    handleUploadImageError(message, photos) {
        this.updatePhotoStatus(message, "fail");
        let positionKey = message.fail[0]["jump_to_key"];
        let positionIndex = this.state.conversationFlow.findIndex(
            (o) => o.key === positionKey
        );
        let add_key = [this.state.conversationFlow[positionIndex]];
        let next_key = [this.state.conversationFlow[positionIndex + 1]];
        if (!message.add_key_on_fail) add_key = add_key.concat(next_key);
        this.state.conversationFlow.splice(
            this.state.conversationPos,
            0,
            ...add_key
        );
        photos[this.state.position]["uploadStatus"] = "error";
        this.setState({ photos });
        this.updatePositions("picture");
    }

    updatePhotoStatus(message, successOrFail) {
        let messageResponse = message[successOrFail],
            afterResponse = _.map(messageResponse, (message) => {
                return message;
            });
        this.state.conversationFlow.splice(this.state.conversationPos, 1);
        this.state.conversationFlow.splice(
            this.state.conversationPos,
            0,
            ...afterResponse
        );
        this.setState({ hideWaves: true });
        this.updateConversation();
    }

    //// Override-mandatory methods ////

    get objectId() {}

    saveLog(message) {}

    static getAppointmentTime(time) {
        return {
            is_today: time.isSame(moment(), "d"),
            is_tomorrow: time.isSame(moment().add(1, "days"), "d"),
            hour: time.format("h:mm A"),
            day: time.format("dddd"),
            day_text: time.calendar(null, {
                sameDay: "[Today]",
                nextDay: "[Tomorrow]",
                nextWeek: "dddd, MMM Do",
            }),
            timezone: moment.tz.zone(moment.tz.guess()).abbr(Date.now()),
        };
    }

    //// Redux ////

    // Use this object (and extend it if needed) when extending this class
    static mapStateToPropsObject = (
        { Session, ChatBot, Experiments, ADO, Personalized },
        chatBotType
    ) => {
        const chatBotConversation = ChatBot.conversationFlow[chatBotType];
        return {
            Session,
            conversations: _.map(
                chatBotConversation,
                function (conversationFlow) {
                    return conversationFlow;
                }
            ),
            chatBotType: chatBotType,
            Experiments,
            ADO,
            P13N: Personalized,
        };
    };

    // Use this object (and extend it if needed) when extending this class
    static mapDispatchToPropsObject = () => {
        return { getItem, setSticky, scheduleAppointment, setCuiVersion };
    };
}

export default BaseChatBot;
